let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("lEC79")).then(() => parcelRequire('dBek7'));